<script setup lang="ts">
const { toast } = useCmsSaveFeedback();

const isError = computed(() => Boolean(toast.value.errorMessage));
const label = computed(() =>
  isError.value ? toast.value.errorMessage : "Saved",
);
</script>

<template>
  <Teleport to="body">
    <Transition name="cms-save-toast">
      <div
        v-if="toast.visible"
        class="cms-save-toast"
        :class="{ 'cms-save-toast--error': isError }"
        role="status"
        aria-live="polite"
      >
        <span
          :key="toast.key"
          class="cms-save-toast__icon"
          aria-hidden="true"
        >
          <svg
            v-if="!isError"
            class="cms-save-toast__check"
            viewBox="0 0 24 24"
            fill="none"
          >
            <circle class="cms-save-toast__circle" cx="12" cy="12" r="10" />
            <path
              class="cms-save-toast__tick"
              d="M7.5 12.2 10.4 15.1 16.5 9"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <svg
            v-else
            class="cms-save-toast__check cms-save-toast__check--error"
            viewBox="0 0 24 24"
            fill="none"
          >
            <circle class="cms-save-toast__circle" cx="12" cy="12" r="10" />
            <path
              class="cms-save-toast__tick"
              d="M9 9l6 6M15 9l-6 6"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </span>
        <span class="cms-save-toast__label">{{ label }}</span>
      </div>
    </Transition>
  </Teleport>
</template>
